import React from "react"
import { HelpCenterReducer } from "./HelpCenterReducer";

export const initialValue = {
    helpCenterFor: "",
    dataItem: {},
    showHelpCenter: false,
    showRatingDialog: false,
    showSubmitIdeaDialog: false,
    showDetailComponent: false,
    showContactUsOptions: false,
    showContactUsDetail: false,
    selectedVideoArticle: {},
    contactUsMethod: "",
    searchKeyword: "",
    searchResult: [],
    user: {}
}

export const HelpCenterContext = React.createContext(initialValue)

export const HelpCenterContextProvider = ({ children, value = {} }) => {

    const [state, dispatch] = React.useReducer(HelpCenterReducer, { ...initialValue, ...value });

    return (
        <HelpCenterContext.Provider value={{
            state,
            dispatch
        }}>
            {children}
        </HelpCenterContext.Provider>
    )
}